const FONT_BASE_URL = 'https://every722.s3.amazonaws.com/everyid-assets/fonts/';

let fontsPromise;

// Shared by the editor, builder preview and public page in this document.
// Keep Card Designer's existing loader and behavior independent.
export function loadLandingPageFonts() {
  if (!fontsPromise) {
    fontsPromise = (async () => {
      if (typeof FontFace === 'undefined' || !document.fonts) return [];

      const response = await fetch(`${FONT_BASE_URL}fonts.json`);
      if (!response.ok) throw new Error(`Font catalog HTTP ${response.status}`);
      const data = await response.json();
      if (!Array.isArray(data.fonts)) throw new Error('Invalid font catalog');

      const families = await Promise.all(data.fonts.map(async ({ family, files }) => {
        const loaded = await Promise.all(Object.entries(files).map(async ([style, file]) => {
          try {
            const face = new FontFace(family, `url("${FONT_BASE_URL}${file}")`, {
              weight: style.includes('bold') ? '700' : '400',
              style: style.includes('italic') ? 'italic' : 'normal',
            });
            await face.load();
            document.fonts.add(face);
            return true;
          } catch (error) {
            console.warn(`Unable to load landing page font ${family} (${style}):`, error);
            return false;
          }
        }));
        return loaded.some(Boolean) ? family : null;
      }));
      return [...new Set(families.filter(Boolean))];
    })().catch(error => {
      console.warn('Unable to load landing page fonts:', error);
      return [];
    });
  }
  return fontsPromise;
}
